document.addEventListener("DOMContentLoaded", () => {
    const feedbackForm = document.querySelector('.feedback__form');
    if (feedbackForm === null) return;
    const feedbackButton = document.querySelector('.feedback__button');
    const feedbackCheckbox = document.querySelector('.feedback__checkbox');

    if (feedbackForm !== null) {
        const feedbackCheckbox = document.querySelector('.feedback__checkbox');
        feedbackCheckbox.addEventListener('change', checkCheckbox);
        feedbackButton.addEventListener('click', checkSumbit);
        checkCheckbox();

        feedbackForm.addEventListener('sumbit', function(e) {
            e.preventDefault();
            if (checkCheckbox()) {
                feedbackForm.submit();
            }
        })
    }

    function checkCheckbox() {
        if (feedbackCheckbox.checked) {
            feedbackButton.classList.remove('feedback__button--disabled');
            removeCheckboxError();
            return true
        } else {
            feedbackButton.classList.add('feedback__button--disabled');
            return false
        }
    }

    function checkSumbit() {
        if (feedbackCheckbox.checked) {
            feedbackButton.classList.remove('feedback__button--disabled');
            removeCheckboxError();
        } else {
            feedbackButton.classList.add('feedback__button--disabled')
            showCheckboxError();
        }
    }

    function showCheckboxError() {
        const errorBlockCheck = feedbackForm.querySelector('.feedback__policy-error');
        if (errorBlockCheck === null) {
            const errorHtml = `<span class="feedback__policy-error">Для отправки необходимо соглашение об использовании сайта</span>`;
            feedbackForm.insertAdjacentHTML('beforeend', errorHtml);
        };
        const errorBlock = feedbackForm.querySelector('.feedback__policy-error');
        errorBlock.classList.add('feedback__policy-error--show');
    }

    function removeCheckboxError() {
        const errorBlock = feedbackForm.querySelector('.feedback__policy-error');
        if (errorBlock === null) return;
        errorBlock.classList.remove('feedback__policy-error--show');
        setTimeout(function() {
            errorBlock.remove()
        }, 300)
    }
});